export default __webpack_public_path__ + "static/media/checkedIcon.cae0f2af.svg";